const FooterSvg = ({ fill = '#FFC11E' }) => {
    return (
        <svg width="1600" height="558" viewBox="0 0 1600 558" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg">
            <path d="M1223.8 65.1774L1331.56 40.9377C1419.84 21.0801 1511.32 20.1073 1600 38.0831V558H-0.00012207V10.8147C56.3435 -3.49939 115.378 -3.44684 171.696 10.9675L197.989 17.6971C250.66 31.178 305.325 35.0858 359.378 29.2339L418.631 22.8192C492.184 14.8564 566.494 17.3597 639.344 30.2543L881.236 73.0697C994.817 93.1739 1111.26 90.4911 1223.8 65.1774Z" fill={fill} />
        </svg>
    )
}

export default FooterSvg
